/* src/app/components/delete-folder-confirmation/delete-folder-confirmation.component.scss */
.inner-content {
  padding: 30px;
}
app-print-group-folder-item {
  width: 65%;
  margin: 10px 0;
  display: block;
}
ion-icon {
  width: 24px;
  height: 24px;
}
ion-icon.title-icon {
  width: 30px;
  height: 30px;
}
.title {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 24px;
  font-weight: 500;
}
hr {
  margin-top: 30px;
  margin-bottom: 30px;
  border-top: 1px solid #cbcbcb;
}
.label {
  font-size: 18px;
  font-weight: 500;
}
.annotation {
  color: #949494;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 16px;
  font-weight: 600;
}
/*# sourceMappingURL=delete-folder-confirmation.component-P6UCM6IC.css.map */
